import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/Layout'
import Seo from '../../components/Seo'

const street_vendor = () => {
	return (
		<Layout>
			<Seo title={`Street Vendor | NAC, Dharamgarh`} />
			<header className="header">
				<div className="header__jumbotron baseWrap df jcsb fww">
					<h2 className="sec_heading">Street Vendor</h2>
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item">
							<span>Services</span>
						</li>
						<li className="breadcrumb-item active">
							<span>Street Vendor</span>
						</li>
					</ol>
				</div>
			</header>
			<section className="sec sec_page df">
				<div className="baseWrap">
					<div className="contentWrap h100 ma shadow df jcc aic">
						<ul className="collection">
							<li className="collection-item">
								<span>Under <strong>PMSVA Nidhi Program</strong>, street vendors can get a loan of upto <strong>Rs. 10,000</strong> at <strong>0%</strong> interest and without any mortgage for a period of 1 year.</span>
							</li>
							<li className="collection-item">
								<div>Documents required:
									<ol className="collection-numbered">
										<li className="collection-item">
											<span>Id proof: Aahar/ Vote card/ PAN</span>
										</li>
										<li className="collection-item">
											<span>Address proof: Ration card/ Aadhar/ Vote</span>
										</li>
										<li className="collection-item">
											<span>PAN Card</span>
										</li>
										<li className="collection-item">
											<span>Bank statement</span>
										</li>
										<li className="collection-item">
											<span>I-Card issued by ULB (Urban local body)</span>
										</li>
									</ol>
								</div>
							</li>
							<li className="collection-item">
								<span>There are <strong>207</strong> street vendors in Dharamgarh.</span>
							</li>
						</ul>
					</div>
				</div>
			</section>
		</Layout>
	)
}

export default street_vendor
